import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-ed',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-ed.component.html',
})
export class MensIntimateWashEdComponent {}
